import { Component, Input, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SessionStorageService } from '../../../services/session-storage.service';
import { PostTradeService } from '../../post-trade.service';
import { NgxLoadingModule } from 'ngx-loading';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { LocalTime } from '../../../local-time.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-aging-cases-table',
  templateUrl: './aging-cases-table.component.html',
  styleUrls: ['./aging-cases-table.component.scss'],
  imports: [
    NgxLoadingModule,
    MatIconModule,
    MatButtonModule,
    LocalTime,
    MatTooltipModule,
  ],
})
export class AgingCasesTableComponent implements OnInit {
  private route = inject(Router);
  ptSvc = inject(PostTradeService);
  ss = inject(SessionStorageService);

  @Input() cases;

  rights = [];
  headers = [
    {
      label: 'Last Updated',
      varName: 'DateLastUpdated',
      dataMask: 'date',
    },
    {
      label: 'Created',
      varName: 'CreatedDate',
      dataMask: 'date',
    },
    {
      label: 'Case ID',
      varName: 'CRID',
    },
    {
      label: 'Rep Code',
      varName: 'SubmittedBy',
    },
    {
      label: 'Rep Name',
      varName: 'SubmittedByName',
    },
    {
      label: 'Case Status',
      varName: 'StatusName',
    },
    {
      label: 'Assigned To',
      varName: 'AssignedTo',
    },
  ];

  ngOnInit(): void {
    this.rights = this.ss.get('rights') ?? [];
  }

  viewCase(ev) {
    this.ptSvc.loading.set(true);
    this.route.navigate([`/case-management/case-manager/${ev}`]);
  }
}
